"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const buttons_1 = require("../../atoms/buttons");
const react_i18next_1 = require("react-i18next");
const data_1 = require("../../shared/data");
const toggle_1 = require("../../atoms/toggle");
const moment_1 = __importDefault(require("moment"));
const form_1 = require("../../atoms/form");
const icons_1 = require("../../atoms/icons");
const tags_1 = __importDefault(require("./tags"));
const AppContexts_1 = require("../../shared/AppContexts");
const ActiveFilters = styled_components_1.default.div `
  & > span {
    margin-top: 0 !important;
    margin-bottom: 0.785rem;
  }
`;
// TODO: TS Remove casting to null after turning on strict mode
const initialFormValues = {
    day: [false, false, false, false, false, false, false],
    isIntakeUndone: false,
    isNew: false,
    daysToPlanEnd: false,
    lastActive: null,
    periodEnd: "",
    periodStart: "",
    subscription: null,
    subscriptionEnd: "",
    subscriptionStart: ""
};
const checkCounter = (counter) => {
    return counter ? `(${counter})` : "";
};
const Filters = ({ mobile, filters, onClose, onChange, tags, onRemoveTag, visible, activeFilterBar, counters = {
    membersToCoachInDay: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0
    },
    subscriptionType: {
        original: 0,
        premium: 0,
        plus: 0
    }
} }) => {
    const { timeFormat } = (0, AppContexts_1.useUserSettingsContext)();
    const [t, i18n] = (0, react_i18next_1.useTranslation)();
    // TODO: TS - Remove translation types casting
    const translations = t("sidebar.filters", {
        returnObjects: true
    });
    moment_1.default.locale(i18n.language);
    const { register, handleSubmit, reset, getValues, setValue } = (0, react_1.useContext)(AppContexts_1.FilterFormContext);
    const onSubmit = () => {
        const formValues = getValues();
        const valuesWithLabels = [];
        for (const key in formValues) {
            const val = formValues[key];
            const labelKey = typeof val == "boolean" ? key : val;
            const label = translations[labelKey] || val;
            if (key === "day") {
                val.forEach((d, idx) => {
                    if (d !== false) {
                        valuesWithLabels.push({
                            key: `day[${idx}]`,
                            value: d,
                            label: moment_1.default.weekdays(parseInt(d) + 1)
                        });
                    }
                });
            }
            else {
                const date = (0, moment_1.default)(val);
                valuesWithLabels.push({
                    key,
                    value: val,
                    label: date.isValid() ? date.format(timeFormat.split(" ")[0]) : label
                });
            }
        }
        onChange && onChange(valuesWithLabels);
    };
    (0, react_1.useEffect)(() => {
        filters.forEach((filter) => {
            if (filter.key == "day") {
                setValue(`day${filter.value}`, "");
            }
            else {
                setValue(filter.key, filter.value);
                const dI = document.querySelector(`[name="${filter.key}"][type="date"]`);
                if (dI) {
                    dI.dispatchEvent(new Event("input"));
                }
            }
        });
    }, [filters]);
    return ((0, jsx_runtime_1.jsxs)(Form, { onChange: onSubmit, onSubmit: handleSubmit(onSubmit), "data-visible": visible, "data-mobile": mobile, "data-cy": "sidebar-filters-container", children: [mobile && ((0, jsx_runtime_1.jsx)(Close, { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["fas", "caret-left"], color: "light-grey", onClick: onClose }, void 0) }, void 0)), (0, jsx_runtime_1.jsxs)(Column, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { style: { marginTop: 0 }, children: translations["title"] }, void 0), activeFilterBar, mobile && ((0, jsx_runtime_1.jsx)(ActiveFilters, { children: (0, jsx_runtime_1.jsx)(tags_1.default, { tags: tags || [], onRemove: onRemoveTag || ((_tag) => { }) }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations["subscriptionType"] }, void 0), data_1.Subscriptions.map((subscription) => {
                        return ((0, jsx_runtime_1.jsx)(toggle_1.Radio, { value: subscription, label: `${subscription} ${checkCounter(counters === null || counters === void 0 ? void 0 : counters.subscriptionType[subscription.toLowerCase()])}`, "data-cy": `filters-checkbox-${subscription}`, ...register("subscription"), name: "subscription" }, subscription));
                    }), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations["coachDay"] }, void 0), moment_1.default.weekdays().map((_day, i) => ((0, jsx_runtime_1.jsx)(SidebarCheckbox, { value: `${i}`, label: `${moment_1.default.weekdays(i + 1)} ${checkCounter(counters.membersToCoachInDay[i])}`, ...register(`day[${i}]`), name: `day[${i}]` }, i)))] }, void 0), (0, jsx_runtime_1.jsxs)(Column, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: translations["sortBy"] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations["lastActive"] }, void 0), ["oldNew", "newOld"].map((key) => ((0, jsx_runtime_1.jsx)(toggle_1.Radio, { label: translations[key], value: key, ...register("lastActive"), name: "lastActive" }, key)))] }, void 0), (0, jsx_runtime_1.jsxs)(InputGroup, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: translations["new"] }, void 0), [
                        "isNewStarter",
                        "isProlonger",
                        "isRejoiner",
                        "hasNewCoach",
                        "hasBirthday",
                        "isIntakeUndone",
                        "daysToSubscriptionsEnd"
                    ].map((key) => ((0, jsx_runtime_1.jsx)(SidebarCheckbox, { label: translations[key], ...register(key), name: key }, key)))] }, void 0), (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("sidebar.filters.subscriptionStart") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", ...register("subscriptionStart"), name: "subscriptionStart" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("general.and") }, void 0), (0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", ...register("subscriptionEnd"), name: "subscriptionEnd" }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("sidebar.filters.periodStart") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", ...register("periodStart"), name: "periodStart" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("general.and") }, void 0), (0, jsx_runtime_1.jsx)(form_1.Input, { type: "date", ...register("periodEnd"), name: "periodEnd" }, void 0)] }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(FormButtons, { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", onClick: () => {
                            reset(initialFormValues);
                        }, children: t("general.reset") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onClose, children: t("general.close") }, void 0)] }, void 0)] }, void 0));
};
const Form = styled_components_1.default.form `
  align-items: self-start;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-right: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: grid;
  height: 100%;
  grid-template-areas: "col1 col2" "additionalFilters additionalFilters" "dates dates" "buttons buttons";
  grid-template-columns: 1fr 1fr;
  grid-template-rows: max-content;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  overflow: auto;
  width: 100%;

  &[data-visible="false"] {
    display: none;
  }

  input[type="date"] {
    max-width: 11rem;
  }

  label {
    h4 {
      text-transform: unset;
      &:first-letter {
        text-transform: capitalize;
      }
    }
  }

  div + p {
    margin-top: ${({ theme }) => theme.spacings.m};
  }

  & > div:first-of-type {
    grid-area: col1;
  }

  & > div:nth-of-type(2) {
    grid-area: col2;
  }

  & > div:nth-last-of-type(3) {
    grid-area: additionalFilters;
  }

  & > div:nth-of-type(4) {
    grid-area: dates;
  }

  & > div:last-of-type {
    grid-area: buttons;
  }

  & > div:last-of-type {
    display: flex;
    margin-top: ${({ theme }) => theme.spacings.s};
    align-self: flex-end;
    margin-bottom: 0;
  }

  & > div:last-of-type button:first-of-type {
    margin-right: ${({ theme }) => theme.spacings.xl};
  }

  button {
    text-transform: capitalize;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    grid-template-areas: "col1" "additionalFilters" "dates" "col2" "buttons";
    grid-template-columns: 1fr;

    input[type="date"] {
      max-width: 100%;
    }

    & > div:first-of-type {
      flex-direction: column;
    }

    h2:last-of-type {
      margin-top: ${({ theme }) => theme.spacings.m};
    }

    & > div:last-of-type {
      flex-direction: column;
      margin-top: ${({ theme }) => theme.spacings.l};
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }

    & > div:last-of-type button:last-of-type {
      margin-top: ${({ theme }) => theme.spacings.m};
    }
  }
`;
const Column = styled_components_1.default.div `
  h2 {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacings.xxs};
  }

  label > h4 {
    color: ${({ theme }) => theme.colors.greyBase};
    font-weight: 400;
  }
`;
const FormButtons = styled_components_1.default.div `
  margin-bottom: 1.25rem;
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0 !important;
  }
`;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacings.m};

  div > p {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  div > div {
    align-items: center;
    display: flex;
  }

  div > div p {
    margin: ${({ theme }) => `0 ${theme.spacings.m} ${theme.spacings.m}`};
  }

  div > input {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    div > div {
      flex-direction: column;
      width: 100%;
    }

    & > div > p:last-of-type {
      margin-top: ${({ theme }) => theme.spacings.m};
    }

    div > div p {
      align-self: flex-start;
      margin: ${({ theme }) => `0 0 ${theme.spacings.xs}`};
    }
  }
`;
const InputGroup = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.xs};

  p {
    margin-bottom: ${({ theme }) => theme.spacings.xxs};
  }

  & > div:nth-of-type(4) {
    margin-bottom: ${({ theme }) => theme.spacings.xxs};
  }

  label {
    align-items: center;

    & h4 {
      color: ${({ theme }) => theme.colors.greyBase};
      flex: 1;
      font-weight: 400;
    }
  }
`;
const Close = styled_components_1.default.span `
  cursor: pointer;
  position: absolute;
  right: 0.45rem;
  top: 0;
  z-index: 1000;
  div {
    background-color: transparent;
  }
`;
const SidebarCheckbox = (0, styled_components_1.default)(toggle_1.Checkbox) `
  margin: 0;

  & h4 {
    padding: ${({ theme }) => `${theme.spacings.xxxs} ${theme.spacings.xs}`};
  }
`;
exports.default = (0, react_1.memo)(Filters);
//# sourceMappingURL=index.js.map